import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import {
  getEmployeeCreditTransactionsInitiate,
  getEmployeeDetailsInitiate,
} from '../../actions/employee';
import EmployeeDetails from './EmployeeDetails';
import { currentFlowTypeEnum } from '../common/components/constants';

const mapStateToProps = state => {
  const employeeData = _get(state, 'employees.employeeData', {});
  const creditTransactions = _get(
    state,
    'employees.creditTransactions.credit_transactions',
    [],
  );
  const groupDetails = _get(employeeData, 'group_details', {});
  const employeeDetails = _get(employeeData, 'employee_details', {});
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    employeeData,
    groupDetails,
    employeeDetails,
    fetchingEmployeeDetails:
      _get(state, 'apiState.GET_EMPLOYEE_DETAILS.isFetching', true) &&
      !_get(state, 'apiState.GET_EMPLOYEE_DETAILS.isIdle', false),
    fetchedEmployeeDetails: _get(
      state,
      'apiState.GET_EMPLOYEE_DETAILS.success',
      true,
    ),
    creditTransactions,
    fetchingCreditTransactions:
      _get(
        state,
        'apiState.GET_EMPLOYEE_CREDIT_TRANSACTIONS.isFetching',
        true,
      ) &&
      !_get(state, 'apiState.GET_EMPLOYEE_CREDIT_TRANSACTIONS.isIdle', false),
    fetchedCreditTransactions: _get(
      state,
      'apiState.GET_EMPLOYEE_CREDIT_TRANSACTIONS.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getEmployeeDetails: payload => dispatch(getEmployeeDetailsInitiate(payload)),
  getEmployeeCreditTransactions: payload =>
    dispatch(getEmployeeCreditTransactionsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmployeeDetails);
